import { getFetchedDataPayload } from '@vista-digital/utilities';
import { loyaltyDomainStore } from '../../../store';
import { getLoyaltySitesByIds } from './get-loyalty-sites-by-ids';
export const getAllLoyaltySites = () => {
    var _a;
    const siteIds = (_a = getFetchedDataPayload(loyaltyDomainStore.data.masterData)) === null || _a === void 0 ? void 0 : _a.siteIds;
    return siteIds ? getLoyaltySitesByIds(siteIds) : undefined;
};
//# sourceMappingURL=get-all-loyalty-sites.js.map